import { render } from "./StatsComponent.vue?vue&type=template&id=45750fbe&scoped=true&lang=html"
import script from "./StatsComponent.vue?vue&type=script&lang=js"
export * from "./StatsComponent.vue?vue&type=script&lang=js"

import "./StatsComponent.vue?vue&type=style&index=0&id=45750fbe&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/aethonspel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45750fbe"]])

export default __exports__